<template>
    <div class="photo-database">
        <div class="photo-database__top"
             :class="{'photo-database__top--scrolled': scrollTop > 0}"
        >
<!--           <h1 class="photo-database__title">-->
<!--               {{ pageTitle }}-->
<!--           </h1>-->
        </div>

        <div class="photo-database__fabs">
            <div class="photo-database__fab">
                <fab-button @click="openSearch">
                    search
                </fab-button>
            </div>

            <div class="photo-database__fab">
                <fab-button @click="openAdd"
                             v-if="autLev.indexOf('3') > -1"
                >
                    add
                </fab-button>
            </div>
        </div>

        <div class="photo-database__overlays">
            <div class="overlay-wrapper">
                <router-view></router-view>
            </div>
        </div>

        <ul class="article-list"
            ref="articleList"
            @scroll="onScroll"
        >
            <li v-if="artItems.length < 1" class="article-list__no-results">
                <p>keine Artikel gefunden</p>
            </li>

            <li class="article-list__item"
                v-for="item in artItems"
                :key="item.id"
            >
                <div class="article"
                     @click.prevent="openInfo(item.id)"
                >
                    <div class="article__status" :class="[getColor(item.besMax, item.besMin)]">
                    </div>

                    <div class="article__number">
                        {{item.artnum}}
                    </div>

                    <div class="article__short-text" v-if="item.image != null">
                        {{item.shorttxt}}
                    </div>

                    <div class="article__visual"
                         @click="doRipple"
                         ref="rippleContainer"
                    >
                        <img class="article__image"
                             v-if="item.image != null"
                             :src="apiurl + '/image' + item.image + '?' + nowTime"
                        >
                        <div class="article__info"
                             v-if="item.image == null"
                        >
                            {{ item.info }}
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import http from '../../http/http';
import FabButton from '../common/fab-button';
import { RippleEffect } from '../../utils';
import { mapGetters } from 'vuex';

export default {
    components: {
        FabButton
    },
    data() {
        return {
            nowTime: '',
            scrollTop: 0
        }
    },
    computed: {
        ...mapGetters('fotodatenbank', [
            'artItems'
        ]),
        ...mapGetters('user', [
            'autLev',
            'userStao'
        ]),
        apiurl() {
            return http.defaults.baseURL;
        },
        pageTitle() {
            return this.$route.meta.title;
        }
    },
    watch: {
        artItems() {
            if (this.$refs.articleList) {
                this.$refs.articleList.scrollTop = 0;
            }
        }
    },
    methods: {
        openAdd() {
            this.$router.push({ name: 'addart' });
        },
        openSearch() {
            this.$router.push({ name: 'search' });
        },
        openInfo(id) {
            this.$router.push('/fotodatenbank/artdetails/' + id + '/' + this.userStao + '/');
        },
        getColor(besMax, besMin) {
            if (besMax > 0 && besMax >= besMin) {
                return 'article__status--green';
            } else if (besMax > 0 && besMax < besMin) {
                return 'article__status--yellow';
            } else if (besMax === 0) {
                return 'article__status--red';
            }
        },
        doRipple(event) {
            const ripple = new RippleEffect(event.target.closest('.article__visual'));
            ripple
                .duration(2000)
                .backgroundColor(`rgba(255, 255, 255, .4)`)
                .position(
                    `${event.offsetX}px`,
                    `${event.offsetY}px`
                )
                .fullAnimation();

            // console.log(ripple);
        },
        onScroll() {
            this.scrollTop = this.$refs.articleList.scrollTop;
        }
    },
    beforeDestroy() {
        this.$store.dispatch('fotodatenbank/delSelectedTrains', []);
    },
    created() {
        this.nowTime = (new Date()).getTime();
    }
}
</script>

<style scoped lang="scss">
    .photo-database {
        position: absolute;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .photo-database__top {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 5.5rem;
        backdrop-filter: blur(20px);
        z-index: 10;
        transition: background-color ease-out .2s;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: opacity ease-out .2s;
            box-shadow: 0 5px 15px rgba($color-black, 0.2);
        }

        &--scrolled {
            background-color: rgba($color-white, 0.95);

            &::before {
                opacity: 1;
            }
        }

        @include medium {
            background-color: rgba($color-white, 0.95);
            padding-top: 1rem;
            padding-left: 6rem;
            padding-bottom: 1.5rem;
        }
    }

    .photo-database__title {
        font-family: $font-family--display;
        font-size: 3rem;
        line-height: 3rem;
        letter-spacing: 2px;
        display: none;
        background-image: linear-gradient(90deg, $color-pastel-blue);
        background-size: 100% 1rem;
        background-position: 0 100%;
        background-repeat: no-repeat;

        @include medium {
            display: inline-block;
        }
    }

    .photo-database__fabs {
        position: absolute;
        right: 1rem;
        top: 1rem;
        display: flex;
        z-index: 10;

        @include medium {
            z-index:1010;
        }
    }

    .photo-database__fab {
        margin-left: 1rem;
    }

    .photo-database__overlays {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: $overlay-z-index;
        pointer-events: none;
    }

    .overlay-wrapper {
        pointer-events: all;
    }

    .article-list {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        margin-top: 5.5rem;
        padding-top: 2.5rem;
        padding-bottom: 50vh;
        overflow: auto;

        @include medium {
            flex-wrap: wrap;
            flex-direction: row;
            align-items: flex-start;
        }

        @include extra-large {
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: center;
        }
    }

    .article-list__no-results {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        color: $color-red;
        font-size: 2rem;
    }

    .article-list__item {
        padding: 1rem;
        list-style: none;
        flex-grow: 1;

        @include medium {
            width: 50%;
        }

        @include extra-large {
            width: 33%;
            flex-grow: 0;
        }
    }

    .article {
        position: relative;
        display: block;
        width: 100%;
        cursor: pointer;
        transition: background-color .3s ease, transform .3s ease;
        box-shadow: 0 5px 15px rgba($color-black, .2);
        overflow: hidden;

        &:hover {
            transform: translateY(-0.5rem);
            transition-delay: .3s;
        }
    }

    .article__number {
        font-size: 2rem;
        padding: 1rem;

        @include extra-large {
            font-size: 2.5rem;
        }
    }

    .article__status {
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;

        &--green {
            background-color: $color-green;
        }

        &--yellow {
            background-color: $color-yellow;
        }

        &--red {
            background-color: $color-red;
        }
    }

    .article__short-text {
        padding: 0 1rem 1rem;
        font-size: 1.25rem;
    }

    .article__visual {
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .article__image {
        width: 100%;
    }

    .article__info {
        padding: 0 1rem 1rem;
    }
</style>
